import {Injectable, ViewChild} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {AngularFireStorage} from '@angular/fire/compat/storage';
import {AngularFireFunctions} from '@angular/fire/compat/functions';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {FormGroup, FormControl, FormBuilder} from '@angular/forms';
import {Ordered} from '../models/ordered';
import {Product} from '../models/product';
import {CieloCode} from '../models/ceilo-code';
import {OrderedFail} from '../models/ordered-fail';
import {OrderRefund} from '../models/refund';
import {Subcategory} from '../models/subcategory';
import {SubcategoryService} from './subcategory.service';
import {RefundService} from './refund.service';
import {ProductService} from './product.service';
import {EventService} from './event.service';
import {firstValueFrom} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrderedService {

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  public isEdit: boolean = false;
  public localTitle: string;
  public spinner: boolean = false;

  // public orderedDataSource: MatTableDataSource<any>;
  public orderedFailDataSource: MatTableDataSource<any>;
  public ordersByMemberDataSource: MatTableDataSource<any>;

  public arrayProduct: any[] = []
  public arrayAnnuities: any[] = []

  public arraySubCategories: Subcategory[] = []

  public arrayCieloCodes: CieloCode[] = []

  public arrayOrderedFail: OrderedFail[] = []

  public arrayAllOrders: Ordered[] = [];

  public arrayMemberOrders: Ordered[] = [];

  public totalSuccess: any;
  public totalFail: any;

  constructor (
    private fb: FormBuilder,
    private db: AngularFirestore,
    private fs: AngularFireStorage,
    private ff: AngularFireFunctions,
    public _subCategoryService: SubcategoryService,
    public _refundService: RefundService,
    public _productService: ProductService,
    public _eventService: EventService,
    private snackBar: SnackBarIconService) { }

  public cielo_values = [
    {
      'brand': 'Master',
      'values': [
        {'installments': 1, 'tax': 5.04},
        {'installments': 2, 'tax': 5.42},
        {'installments': 3, 'tax': 6.64},
        {'installments': 4, 'tax': 7.86},
        {'installments': 5, 'tax': 9.08},
        {'installments': 6, 'tax': 10.30}
      ]
    },
    {
      'brand': 'Visa',
      'values': [
        {'installments': 1, 'tax': 5.04},
        {'installments': 2, 'tax': 5.42},
        {'installments': 3, 'tax': 6.64},
        {'installments': 4, 'tax': 7.86},
        {'installments': 5, 'tax': 9.08},
        {'installments': 6, 'tax': 10.30}
      ]
    },
    {
      'brand': 'Elo',
      'values': [
        {'installments': 1, 'tax': 4.83},
        {'installments': 2, 'tax': 6.65},
        {'installments': 3, 'tax': 7.87},
        {'installments': 4, 'tax': 9.09},
        {'installments': 5, 'tax': 10.31},
        {'installments': 6, 'tax': 11.53}
      ]
    }
  ]

  selectAll () {
    return this.db.collection<Ordered>('sbccv_orders').get()
  }

  select (): any {

    return this.db.collection<Ordered>('sbccv_orders').snapshotChanges()
      .subscribe((result) => {
        result.forEach((item) => {
          if (item.payload.doc.data().returnCode == "00") {
            this.arrayAllOrders.push(this.createOrderObj(item))
          }
        })
      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Acesso negado", '', 'error');
        })
  }

  getById (id) {
    return this.db.doc<Ordered>('sbccv_orders/' + id)
      .get();
  }

  async geteOrderById(id: string) {
    const order = await firstValueFrom(this.db.doc<Ordered>(`sbccv_orders/${id}`).get());
    return order;
  }

  selectByProductAndMemberId (product_id, member_id) {
    return this.db.collection<Ordered>('sbccv_orders', ref => ref
      .where('product_id', '==', product_id)
      .where('member_id', '==', member_id)
      .where('returnCode', '==', "00")
      .orderBy('date', 'desc')).get()
  }

  requestRefund (order_id, percent, value) {

    return this.db.collection('sbccv_orders').doc(order_id).set(
      {
        'returnCode': 'refundrequest',
        'refund': {
          'dateRequest': new Date(),
          'account': '',
          'agency': '',
          'bank': '',
          'bankName': '',
          'discount': percent,
          'total': value,
        }
      }, {'merge': true});

  }

  loadOrdered (product_id: any) {

    return this.db.collection<Ordered>('sbccv_orders', ref => ref
      .where('product_id', '==', product_id)
      .orderBy('date', 'desc')).snapshotChanges()

  }

  loadLastTwoDaysOrder () {
    const twoDaysAgo: Date = new Date();
    twoDaysAgo.setDate(twoDaysAgo.getDate() - 2);

    return this.db.collection<Ordered>('sbccv_orders', ref => ref
      .where('date', '>=', twoDaysAgo)
      .where('returnCode', '==', '00')
      .orderBy('date', 'desc'))
      .snapshotChanges();
  }

  loadValidOrdered (product_id: any) {

    return this.db.collection<Ordered>('sbccv_orders', ref => ref
      .where('product_id', '==', product_id)
      .where('returnCode', '==', '00')
      .orderBy('date', 'desc')).snapshotChanges()

  }

  loadAllOrdered () {

    return this.db.collection<Ordered>('sbccv_orders', ref => ref
      .orderBy('date', 'desc')).snapshotChanges()

  }

  compareNames (a, b) {

    const pa = String(a.member_name)
    const pb = String(b.member_name)

    if (pa > pb) return 1;
    if (pb > pa) return -1;

    return 0;
  }

  getCieloMessage (returnCode): string {

    let cielo: CieloCode = this.arrayCieloCodes.find((e) => {
      return returnCode == e.code
    })

    if (cielo) {
      return cielo.message;
    } else {
      return "";
    }

  }

  loadCieloCodes () {

    return this.db.collection<CieloCode>('sbccv_cielo_codes').snapshotChanges()
      .subscribe((result) => {
        result.forEach((item) => {
          let code = new CieloCode();
          code.code = item.payload.doc.data().code
          code.message = item.payload.doc.data().message
          this.arrayCieloCodes.push(code)
        })
      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Acesso negado", '', 'error');
        })
  }

  delete (entity_id: string) {
    return this.db.collection('sbccv_orders').doc(entity_id).delete();
  }

  /*
  _delete (entity_id: string, product_id: string) {
    this._productService.loadProductItensByProduct(product_id)
      .subscribe((prodItems) => {
        prodItems.forEach((item) => {
          console.log("event name: " + item.payload.doc.data().event_name)
          this._eventService.getById(item.payload.doc.data().event_id)
            .subscribe((event) => {
              console.log("event id: " + event.id)
              console.log("event control_ticket_by_topic: " + event.data().control_ticket_by_topic)

            })
        })

      })

  }
  */

  getOrdersByMemberId (member_id: any) {

    return this.db.collection<Ordered>('sbccv_orders', ref => ref
      .where('member_id', "==", member_id)
      //.where('staff', "==", false)
      .where('returnCode', "==", "00")
      .orderBy("date", 'desc')).snapshotChanges()
      .subscribe((result) => {

        let array: Ordered[] = [];

        result.forEach((item) => {
          let obj: any = {}
          obj.id = item.payload.doc.id;
          obj.order_date = item.payload.doc.data().date;
          obj.product_id = item.payload.doc.data().product_id;
          obj.product_name = item.payload.doc.data().product_name;
          obj.topic_name = item.payload.doc.data().topic_name;
          obj.member_name = item.payload.doc.data().member_name;
          obj.category_name = item.payload.doc.data().category_name;
          obj.Tid = item.payload.doc.data().Tid;
          obj.tax = 0

          if (item.payload.doc.data().payment_type == "cartao" || item.payload.doc.data().payment_type == "CreditCard") {
            obj.payment_type_display = "Cartão de Crédito"
            if (item.payload.doc.data().card_installments == 1) {
              obj.tax = 0.037
            } else {
              obj.tax = 0.047
            }
          } else if (item.payload.doc.data().payment_type == "Billet") {

            obj.payment_type_display = "Boleto Bancário"
            obj.tax = 3.5

          } else if (item.payload.doc.data().payment_type == "Free") {

            obj.payment_type_display = "Cortesia"
            obj.tax = 0

          }

          obj.value = item.payload.doc.data().value;
          obj.member_debit = item.payload.doc.data().member_debit;
          obj.discount = item.payload.doc.data().discount;

          let tax_value = 0//obj.tax * obj.value
          if (item.payload.doc.data().payment_type == "Billet") {
            tax_value = obj.tax
          } else {
            tax_value = obj.tax * obj.value
          }

          obj.valor_liquido = obj.value - tax_value

          obj.origin = item.payload.doc.data().origin;

          if (obj.product_name === undefined) {
            obj.product_name = "undefined " + obj.product_id

            var prod = this.arrayProduct.find((e) => {
              return e.id == obj.product_id
            })

            if (prod) {
              obj.product_name = prod.name
            } else {
              console.log("NÃO ACHOU")
            }
          }

          obj.receiptUrl = item.payload.doc.data().receiptUrl ? item.payload.doc.data().receiptUrl : "";

          array.push(obj)
        })

        this.ordersByMemberDataSource = new MatTableDataSource(array);
      })
  }

  createOrderObj (item) {

    const payment_date = item.payload.doc.data().payment_date;
    let payDate: Date;

    if (payment_date && typeof payment_date === 'string') {
      const year = payment_date.substring(0, 4)
      const month = payment_date.substring(5, 7)
      const day = payment_date.substring(8, 10)
      payDate = new Date(Number(year), Number(month)-1, Number(day))
     // console.log(payDate)
    } else if (payment_date && payment_date.toDate() instanceof Date) {
     // console.log("payment_date: " + payment_date)
      payDate = payment_date.toDate();
    }


    // console.log("payDateAsaas: " + payDateAsaas)
    // console.log("payDate: " + payDate);
    // console.log("--------------------------------------------")

    /*
    if(payDateAsaas){
      console.log(payDateAsaas)
    }
    */


    let order: any = {} //new Ordered();
    order.id = item.payload.doc.id

    order.date = item.payload.doc.data().date;
    order.payDate = payDate; //item.payload.doc.data().payment_date;

    order.product_id = item.payload.doc.data().product_id;
    order.product_name = item.payload.doc.data().product_name;
    order.member_id = item.payload.doc.data().member_id;
    order.member_name = item.payload.doc.data().member_name;
    order.member_cpf = item.payload.doc.data().member_cpf;
    order.member_cellPhone = item.payload.doc.data().member_cellPhone;
    order.member_email = item.payload.doc.data().member_email;
    order.member_debit = item.payload.doc.data().member_debit;
    order.category_id = item.payload.doc.data().category_id;

    order.nonMemberCategory_id = item.payload.doc.data().nonMemberCategory_id ? item.payload.doc.data().nonMemberCategory_id : "";

    let cat: Subcategory;
    if (order.category_id == "H2AoWhktluQaWYuPydHC") { //não sócio, 
      cat = this.arraySubCategories.find((e) => {
        return e.id == order.nonMemberCategory_id
      })
      if (cat) {
        order.category_name = item.payload.doc.data().category_name + "/" + cat.name
      } else {
        order.category_name = item.payload.doc.data().category_name
      }

    } else {
      order.category_name = item.payload.doc.data().category_name
    }

    order.payAsOverdue = item.payload.doc.data().payAsOverdue;
    order.until_date = item.payload.doc.data().until_date;
    order.lot_id = item.payload.doc.data().id;

    order.payment_date = item.payload.doc.data().payment_date;
    order.payment_type = item.payload.doc.data().payment_type;

    order.value = item.payload.doc.data().value;
    order.rawValue = item.payload.doc.data().rawValue;
    order.api = item.payload.doc.data().api || "";
    order.installments = item.payload.doc.data().installments || "";

    order.total = item.payload.doc.data().total;
    order.total_minus_tax = item.payload.doc.data().total_minus_tax;

    order.member_debit = item.payload.doc.data().member_debit;

    if (item.payload.doc.data().discount)
      order.discount = item.payload.doc.data().discount;
    else
      order.discount = 0.00;

    order.card_brand = item.payload.doc.data().card_brand;
    order.card_number = item.payload.doc.data().card_number;
    order.card_installments = item.payload.doc.data().card_installments;
    order.card_softdescriptor = item.payload.doc.data().card_softdescriptor;
    order.card_holder = item.payload.doc.data().card_holder;
    order.card_expirationDate = item.payload.doc.data().card_expirationDate;

    order.billet_name = item.payload.doc.data().billet_name;
    order.billet_identity = item.payload.doc.data().billet_identity;
    order.billet_street = item.payload.doc.data().billet_street;
    order.billet_number = item.payload.doc.data().billet_number;
    order.billet_complement = item.payload.doc.data().billet_complement;
    order.billet_zipCode = item.payload.doc.data().billet_zipCode;
    order.billet_district = item.payload.doc.data().billet_district;
    order.billet_city = item.payload.doc.data().billet_city;
    order.billet_state = item.payload.doc.data().billet_state;
    order.billet_country = item.payload.doc.data().billet_country;

    order.type = item.payload.doc.data().type;
    order.paymentId = item.payload.doc.data().paymentId;
    order.Tid = item.payload.doc.data().Tid;
    order.returnCode = item.payload.doc.data().returnCode;
    order.proofOfSale = item.payload.doc.data().proofOfSale;
    order.authorizationCode = item.payload.doc.data().authorizationCode;

    order.tax = item.payload.doc.data().tax;

    order.cash_operator = item.payload.doc.data().cash_operator;
    order.origin = item.payload.doc.data().origin;

    order.topic_name = item.payload.doc.data().topic_name || '';
    order.topic_id = item.payload.doc.data().topic_id || '';
    order.topic_text1 = item.payload.doc.data().topic_text1 || '';
    order.topic_text2 = item.payload.doc.data().topic_text2 || '';
    order.topic_text3 = item.payload.doc.data().topic_text3 || '';

    order.refund = item.payload.doc.data().refund;

    return order;

  }

  createIntervalForm () {
    let form: FormGroup = this.fb.group({
      start: new FormControl(''),
      end: new FormControl(''),
      product_id: new FormControl('')
    })
    return form;
  }

  loadProducts () {
    return this.db.collection<Product>('sbccv_products', ref =>
      ref.where('active', "==", true)).snapshotChanges()
      .subscribe((result) => {

        result.forEach((item) => {
          let product = new Product();
          product.id = item.payload.doc.id;
          product.name = item.payload.doc.data().name;
          product.text = item.payload.doc.data().text;
          product.image = item.payload.doc.data().image;
          this.arrayProduct.push(product);
        });
      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Acesso negado", '', 'error');
        })
  }


  makeMsgError (errorsCode) {
    let msgError: string

    switch (errorsCode) {
      case "auth/email-already-exists":
        msgError = "Este email já está em uso"
        break;
    }

    return msgError
  }

  updateCsvOrdered (_ordered) {

    _ordered.forEach(element => {
      this.db.collection('sbccv_orders').add(Object.assign({}, element))
        .then((result) => {
          return element.date + " - add - "// + element.member_name
        })
        .catch((error) => {
          console.log(JSON.stringify(error))
        })
    });
  }


  insert (entity: Ordered) {
    entity.id = ""
    return this.db.collection('sbccv_orders').add(Object.assign({}, entity));
  }

  update (entity: Ordered) {
    let id = entity.id;
    return this.db.collection('sbccv_orders').doc(id).set(Object.assign({}, entity), {'merge': true});
  }

  updateOrder (id: string, entity: any) {
    return this.db.collection('sbccv_orders').doc(id).set(Object.assign({}, entity), {'merge': true});
  }

  updateMemmberOrder (id: string, entity: any) {
    return this.db.collection('sbccv_orders').doc(id).update(Object.assign({}, entity));
  }

  updateRefund (entity: OrderRefund) {
    console.log("refund: " + JSON.stringify(entity))

    let id = entity.order_id;
    //delete entity.order_id;

    let obj = Object.assign({}, entity)

    return this.db.collection('sbccv_orders').doc(id).set(
      {'returnCode': 'refund', 'refund': obj}, {merge: true}
    );

  }

  loadSubcategories () {

    this._subCategoryService.select()
      .subscribe((result) => {

        this.arraySubCategories = result.map(item => {
          let entity = new Subcategory();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name
          return entity;
        });

      })

  }


}
